import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import { formatUSD } from '../../../helpers';
// import useUserTotalWithdrawals from '../../../hooks/web3/pools/useUserTotalWithdrawals';
import useMockUserTotalWithdrawals from '../../../hooks/web3/pools/useMockUserTotalWithdrawals';
import PoolSummaryHeader from '../PoolSummaryHeader';
import TotalWithdraws from './TotalWithdraws';

const PoolTotalWithdraws = () => {
    // const { userTotalWithdrawals, isLoading } = useUserTotalWithdrawals();
    const { userTotalWithdrawals, isLoading } = useMockUserTotalWithdrawals();

    return (
        <div className='pool-total-withdraws-container'>
            <PoolSummaryHeader
                title='Historical Withdrawals'
                value={
                    userTotalWithdrawals
                        ? formatUSD(userTotalWithdrawals.totalWithdrawnAsset, {
                              minDecimals: 2,
                          })
                        : '-'
                }
            />
            <div className='total-withdraws-container'>
                {isLoading ? (
                    <Card className='withdraw-text'>
                        <div className='loading-container'>
                            <Spinner />
                            <span>Loading your withdrawals...</span>
                        </div>
                    </Card>
                ) : userTotalWithdrawals ? (
                    userTotalWithdrawals.totalWithdrawalsPerPool.length ? (
                        userTotalWithdrawals.totalWithdrawalsPerPool.map(
                            (userTotalWithdraw, index) => (
                                <TotalWithdraws
                                    userTotalWithdraw={userTotalWithdraw}
                                    key={index}
                                />
                            )
                        )
                    ) : (
                        <Card className='deposit-text'>
                            You have no locked deposits...
                        </Card>
                    )
                ) : (
                    <Card className='deposit-text'>
                        We had trouble loading your withdrawals...
                    </Card>
                )}
            </div>
        </div>
    );
};

export default PoolTotalWithdraws;
